import { Component, Injector, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { Filter, FilterConditionOperation } from 'src/app/classes';
import { DataService } from 'src/app/services/data.service';
import { FilterType, FilterTypeCriteria } from '../../edit/edit-userfilter/edit-userfilter.component';

@Component({
  selector: 'app-filter-structure-preview',
  templateUrl: './filter-structure-preview.component.html',
  styleUrls: ['./filter-structure-preview.component.css']
})
export class FilterStructurePreviewComponent implements OnDestroy, OnInit {

  isFirstOperator: boolean;

  operator: string;

  criteria: ConditionWrapper[] = [];

  _filter: Filter;
  _filterType: FilterType<number>;
  @Input() set filterType(type: FilterType<number>){
    this._filterType = type;
    this.loadConditions();
  }
  get filterType(): FilterType<number> {
    return this._filterType;
  }
  @Input() set filter(filter: Filter){
    if(filter){
      this._filter = filter;
      switch(filter.type){
        case "AND":
          this.operator = "und";
          break;
        case "OR":
          this.operator = "oder";
          break;
      }
      this.criteria = [];
      for(let condition of filter.filtercondition){
        this.criteria.push({ value: condition.value, attribute: condition.attribute, operation: condition.operation } as ConditionWrapper);
      }
    } else {
      this._filter = null;
      this.operator = null;
    }
    this.loadConditions();
  }
  get filter(): Filter {
    return this._filter;
  }

  private _subscriptions: Subscription[] = [];

  constructor(
    private _dataService: DataService,
    private _injector: Injector
  ) {

  }

  loadConditions(){
    if(this.filterType && this.filter){
      for(let criteria of this.criteria){
        let c: FilterTypeCriteria<number> = this.filterType.criteria.find(x => x.value == criteria.attribute);
        if(c) c.suggestionsProvider(c, this._injector).subscribe((result) => console.log(result));
      }
    }
  }

  ngOnDestroy(): void {
    for(let sub of this._subscriptions) sub.unsubscribe();
    this._subscriptions = [];
  }

  ngOnInit(): void {
  }

  FilterConditionOperation = FilterConditionOperation;

}

class ConditionWrapper {
  value: string;
  attribute: string;
  operation: number;
}
